import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { useApiKeysQuery, useRequestLogQuery } from '@dashboard/generated/wp/platform';
import { Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';

import PreviewBox from './PreviewBox';

export default function DisplayRequestLog() {
  const id = useParams<{ requestLogId: string | undefined }>().requestLogId!;
  const { data } = useRequestLogQuery({ variables: { id } });
  const { data: apiKeysData } = useApiKeysQuery();

  const model = data?.RequestLog;

  const renderApiKeyName = (apiKeyId: string | null | undefined) => {
    if (!apiKeyId) {
      return '--';
    }

    const nodes = apiKeysData?.ApiKeys.nodes;
    if (nodes === undefined) {
      return '';
    }
    return nodes.find((a) => a.id === apiKeyId)!.name;
  };

  if (model === undefined) {
    return (
      <Card
        sx={{
          height: 'calc(100vh - 80px)',
          overflow: 'auto',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <CardContent>
          <LoadingIndicator />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: 'calc(100vh - 80px)', overflow: 'auto' }}>
      <CardHeader
        title={
          <Typography variant="h4" component="h1">
            Request
          </Typography>
        }
        disableTypography
      />
      <Stack component={CardContent} spacing={5}>
        <Stack spacing={1}>
          <Stack spacing={2} direction="row" alignItems="center">
            <Typography variant="body1">{model.statusCode}</Typography>
            <Typography variant="body1" fontWeight="medium">
              {model.method}
            </Typography>
            <Typography color="text.secondary">{model.url}</Typography>
          </Stack>
          <Divider />
          <Typography variant="body2" color="text.secondary">
            API Key: {renderApiKeyName(model.apiKeyId)}
          </Typography>
        </Stack>
        <Fragment key={model.id}>
          <PreviewBox title="Headers" value={model.requestHeaders} />
          <PreviewBox title="Body" value={model.requestBody} />
          <PreviewBox title="Response" value={model.responseBody} />
        </Fragment>
      </Stack>
    </Card>
  );
}
